import React from 'react';
import IconButton from 'material-ui/IconButton';
import { Grid, Icon } from '../../components';
import { projetoService } from '../../services';
import PrincipalMaster from '../master/Principal';

class ProjetosAutor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsProjetosAutor: [],
            modalEnviarArquivosOpen: false,
            codigoProjeto: 0,
            arquivoApresentacao: null,
            videoApresentacao: null,
            progressoUploadApresentacao: 0,
        };
    }

    async componentWillMount() {
        await this.getProjetosAutor();
    }

    async getProjetosAutor() {
        const projetos = await projetoService.getProjetosAutor();
        this.setState({
            dsProjetosAutor: projetos,
        });
    }

    render() {
        const { dsProjetosAutor } = this.state;

        return (
            <PrincipalMaster title="Informações do Projeto" {...this.props}>
                <div className="padding-content">
                    <h3>Meus Resumos/Projetos</h3>
                    <Grid
                        ref={(ref) => {
                            this.projetosAutorGridRef = ref;
                        }}
                        stripedRows="true"
                        textTableEmpty="Nenhum projeto encontrado."
                        dataSource={dsProjetosAutor}
                        showSearch={false}
                        columnSortDefault={3}
                        sortAscDirection={false}
                        columns={[
                            {
                                text: 'Título',
                                name: 'TITULO',
                                allowSort: true,
                                allowSearch: true,
                                searchOperator: 'LIKE',
                            },
                            {
                                text: 'Área',
                                name: 'AREA',
                                allowSort: true,
                                allowSearch: true,
                                searchOperator: 'LIKE',
                            },
                            {
                                text: 'Evento',
                                name: 'EVENTO',
                                allowSort: true,
                                allowSearch: true,
                                searchOperator: 'LIKE',
                            },
                            {
                                text: 'Ano',
                                name: 'ANO',
                                allowSort: true,
                                allowSearch: true,
                                searchOperator: 'LIKE',
                            },
                            {
                                text: 'Subevento',
                                name: 'SUBEVENTO',
                                allowSort: true,
                                allowSearch: true,
                                searchOperator: 'LIKE',
                            },
                            {
                                text: 'Pago',
                                name: 'PAGO',
                                allowSort: true,
                                allowSearch: true,
                                searchOperator: 'LIKE',
                            },
                            {
                                text: 'Apresentação enviada',
                                name: 'APRESENTACAOENVIADA',
                                allowSort: false,
                                allowSearch: false,
                            },
                            {
                                name: (item) => (
                                    <div>
                                        <a
                                            href={`/inscricao/resumo/${item.CODIGO}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <IconButton>
                                                <Icon name="visibility" />
                                            </IconButton>
                                        </a>
                                    </div>
                                ),
                            },
                        ]}
                    />
                    <br />
                </div>
            </PrincipalMaster>
        );
    }
}

export default ProjetosAutor;
